@if (isLoading() && loadingText()) {
  <div class="loading-spinner">
    <span>{{ loadingText() }}</span>
  </div>
}

<div #loadAnchorElement class="invisible-element"></div>
